import useTodaysEvents from '$tablet-app/src/app/calendar/combined/useTodaysEvents';
import FullScreenLoader from '$tablet-app/src/app/components/FullScreenLoader';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';

import TodayBadge from '$tablet-app/src/app/components/TodayBadge';
import useCurrentDay from '$tablet-app/src/app/utils/useCurrentDay';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { format } from 'date-fns';
import React, { FC } from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import CalendarItemCard from '../../calendar/components/CalendarItemCard';
import { CalendarItemUnion } from '../../calendar/types';
import { useMainDrawerNavigation } from '../../navigation/hooks';
import DashboardPanel from '../DashboardPanel';

const TodaysEvents: FC = () => {
  const day = useCurrentDay();
  const { navigate } = useMainDrawerNavigation();
  const { items, isLoading } = useTodaysEvents();

  const onClickTile = (item: CalendarItemUnion) => {
    // openCalendarItem({ id: item.id, type: item.type });
    navigate('CalendarItemDetails', { id: item.id, type: item.type });
  };

  const onClickPlaceholder = () => navigate('Calendar');

  if (!isLoading && !items.length) {
    return (
      <PlaceholderPanel>
        <PlaceholderTextRow>
          <FontAwesomeIcon
            icon="calendar-day"
            size={25}
            color={colors.orange.crayola}
          />
          <Text variant="h3" weight="semibold">
            Calendar
          </Text>
        </PlaceholderTextRow>

        <Button
          size="large"
          icon="plus"
          variant="secondary"
          onPress={onClickPlaceholder}
        >
          Create an event
        </Button>
      </PlaceholderPanel>
    );
  }

  return (
    <>
      <Row justifyContent="space-between">
        <Text variant="h3" weight="semibold">
          {format(new Date(day), 'd EEEE')}
        </Text>

        <StyledTodayBadge color="white" />
      </Row>

      <Spacer height="15px" />

      {isLoading ? (
        <FullScreenLoader />
      ) : (
        <ScrollView>
          {items.map((i) => (
            <Tile key={i.id} item={i} onPress={onClickTile} />
          ))}
        </ScrollView>
      )}
    </>
  );
};

const Tile = styled(CalendarItemCard)`
  margin-bottom: 10px;
`;

const StyledTodayBadge = styled(TodayBadge)`
  background-color: ${colors.primary[700]};
`;

const PlaceholderPanel = styled(DashboardPanel)`
  background-color: #ffebe3;
  border-color: white;
  border-width: 2px;

  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 30px;
`;

const PlaceholderTextRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 14px;
`;

export default TodaysEvents;
